import LegalPage, { Section } from "@/components/LegalPage";

const Terms = () => (
  <LegalPage title="Terms & Conditions" updated="Last updated: 2026" testid="terms-page">
    <Section title="1. Introduction">
      <p>
        These Terms &amp; Conditions govern the use of br-hospitality.com, operated by BR
        Hospitality (&ldquo;BR Hospitality&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;). By using
        this website, you accept these terms. If you do not agree, please do not use the website.
      </p>
    </Section>

    <Section title="2. Our Services">
      <p>
        BR Hospitality provides hospitality recruitment, executive search, pre-opening support and
        strategic advisory services to hotels, resorts, restaurants and hospitality groups across
        Europe, the Middle East and Asia. Content on this website is provided for general
        information and does not constitute a binding offer of services.
      </p>
    </Section>

    <Section title="3. Use of the Website">
      <p>
        You agree to use this website lawfully and not to misuse it, including by attempting
        unauthorised access, submitting false or misleading information, or interfering with its
        operation.
      </p>
    </Section>

    <Section title="4. Candidate Submissions">
      <p>
        By submitting a profile or CV, you confirm that the information provided is accurate and
        that you have the right to share it. Submission of a profile does not guarantee placement,
        introduction or employment. We never charge candidates fees for recruitment services.
      </p>
    </Section>

    <Section title="5. Employer Engagements">
      <p>
        Recruitment, pre-opening and advisory engagements are subject to separate written
        agreements between BR Hospitality and the client. Nothing on this website creates a
        client relationship or obligation on either party.
      </p>
    </Section>

    <Section title="6. Intellectual Property">
      <p>
        All content on this website — including the BR monogram, brand identity, text and design —
        is the property of BR Hospitality and may not be reproduced or used without prior written
        permission.
      </p>
    </Section>

    <Section title="7. Third-Party Links">
      <p>
        This website may contain links to third-party platforms such as LinkedIn. We are not
        responsible for the content or practices of third-party websites.
      </p>
    </Section>

    <Section title="8. Limitation of Liability">
      <p>
        This website is provided &ldquo;as is&rdquo;. To the fullest extent permitted by law, BR
        Hospitality accepts no liability for any loss or damage arising from the use of this
        website or reliance on its content.
      </p>
    </Section>

    <Section title="9. Governing Law">
      <p>
        These terms are governed by the laws applicable at the principal place of business of BR
        Hospitality, without regard to conflict-of-law provisions.
      </p>
    </Section>

    <Section title="10. Changes to These Terms">
      <p>
        We may update these Terms &amp; Conditions from time to time. The current version will
        always be published on this page.
      </p>
    </Section>

    <Section title="11. Contact">
      <p>
        BR Hospitality — Recruitment &amp; Advisory
        <br />
        Email:{" "}
        <a href="mailto:info@br-hospitality.com" className="text-bronze link-underline">
          info@br-hospitality.com
        </a>
        <br />
        Phone: +63 995 354 4784
        <br />
        Website: br-hospitality.com
      </p>
    </Section>
  </LegalPage>
);

export default Terms;
